<app-breadcrumb [title]="'Listado Marcas'" [items]="['Vehiculos', 'Marca']" [active_item]="'Listado Marcas'"></app-breadcrumb>
<div class="container-fluid">

    <div class="card">
      <div class="card-header bg-primary text-white ">
        <h5 class="text-uppercase">
          <strong>Listado de Marcas ACTIVAS</strong>
        </h5>
      </div>
   
      <div class="card-body custom-datatable noscroll">
        <div class="row mb-12 ">
      <div class="col-sm-12 col-md-3 ms-auto">
        <div class="input-group">
          <input type="text" class="form-control" placeholder="Buscar....." [(ngModel)]="searchText"
            (input)="filterData()" />
          <span class="input-group-text">
            <i class="fa fa-search"></i> <!-- Icono de búsqueda -->
          </span>
        </div>
      </div>
    </div>
        <div class="custom-datatable table-responsive mt-4">
         <table class="table table-hover table-bordered" id="tblMarcas">
  <thead class="bg-primary">
    <tr>
      <th class="text-center" style="cursor: pointer" (click)="sortData('marca')">
        <strong>NOMBRE DE MARCA</strong>
        <i class="fa ms-1" [ngClass]="{
          'fa-sort-up': sortColumn === 'marca' && sortDirection === 'asc',
          'fa-sort-down': sortColumn === 'marca' && sortDirection === 'desc',
          'fa-sort': sortColumn !== 'marca'
        }"></i>
      </th>
      <th class="text-center"><strong>OPCIONES</strong></th>
    </tr>
  </thead>

  <tbody *ngIf="filteredTableItems.length > 0; else sinMarcas">
    <tr *ngFor="let marca of filteredTableItems | paginate: { itemsPerPage: pageSize1, currentPage: page1 }">
      <td class="text-center">{{ marca.marca }}</td>
      <td>
        <div class="action text-center">
          <ul class="list-inline d-flex justify-content-center gap-3">
            <li class="list-inline-item edit">
              <a href="javascript:void(0)"  title="Editar">
                <i class="icon-pencil-alt" (click)="openModalMarca(myModal3, marca.id)" ngbTooltip="Editar"></i>
              </a>
            </li>
            <li class="list-inline-item delete">
              <a href="javascript:void(0)"  title="Eliminar">
                <i class="icon-trash" (click)="actualizarEstadoAInactivo(marca.marca)" ngbTooltip="Inactivar"></i>
              </a>
            </li>
          </ul>
        </div>
      </td>
    </tr>
  </tbody>

  <ng-template #sinMarcas>
    <tbody>
      <tr>
        <td class="text-center" colspan="2">🚫 No hay marcas inactivas registradas.</td>
      </tr>
    </tbody>
  </ng-template>
</table>

        </div>
      <div class="row align-items-center mt-4 g-2">
    <!-- Selector de registros por página -->
    <div class="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-start">
      <label for="pageSize1" class="me-2 mb-0">Mostrar:</label>
      <select id="pageSize1" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
        <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">{{ size1 }}</option>
      </select>
      <span class="ms-2">registros por página</span>
    </div>

    <!-- Total de registros -->
    <div class="col-12 col-md-4 text-center my-2 my-md-0">
      <span class="badge bg-primary ms-1"><b><span>Total Registros: </span>{{ marcas.length || 0 }}</b></span>
    </div>

    <!-- Paginador -->
    <div class="col-12 col-md-4 text-center text-md-end">
      <pagination-controls 
        (pageChange)="page1 = $event" 
        [maxSize]="5"
        [directionLinks]="true"
        [autoHide]="true"
        previousLabel="Anterior" 
        nextLabel="Siguiente">
      </pagination-controls>
    </div>

    </div>
        <div class="card-body">
          <div class="btn-showcase text-center">
            <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
              (click)="
                exportarExcel(
                  'tblMarcas',
                  'Listado_Marcas'
                )
              ">
              <i class="icofont icofont-file-excel"></i> EXCEL
            </button>

            <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF"
              (click)="
                exportToPDF(
                  'tblMarcas',
                  'Listado_Marcas',
                  'Listado de Marcas'
                )
              ">
              <i class="icofont icofont-file-pdf"></i> PDF
            </button>

            <button class="btn btn-primary" type="button" placement="top" ngbTooltip="Crear Marca"
              (click)="openModalMarca(myModal3)">
              <i class="icofont icofont-plus"></i> Agregar
            </button>
          </div>
        </div>
      </div>
    </div>

</div>

<ng-template #myModal3 let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0">
        {{ editMode ? 'EDITAR MARCA' : 'CREACIÓN DE MARCA' }}
      </h5>
    </div>
    <div class="modal-body">
      <form [formGroup]="formMarca">
        <div class="row g-3 mb-3">
          <div class="col-md-12">
            <label class="form-label" for="marca"><strong>Marca *:</strong></label>
            <input class="form-control" id="marca" type="text" placeholder="Ingrese la marca"
              formControlName="marca" autocomplete="off"/>
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button class="btn btn-primary" (click)="guardarMarca()">
        {{ editMode ? "Actualizar" : "Guardar" }}
      </button>
      <button class="btn btn-secondary" (click)="modal.dismiss()">
        Cancelar
      </button>
    </div>
  </div>
</ng-template>